/** General Configurations Like PORT, HOST names and etc... */

var config = {
	env: process.env.NODE_ENV || 'development',
	host: process.env.HOST || 'localhost',
	port: process.env.PORT || 8889,
	karmaPort: 9876,

	// This part goes to React-Helmet for Head of our HTML
	app: {
		head: {
			title: 'GLOSSIQ',
			titleTemplate: 'GLOSSIQ: %s',
			meta: [
				{ charset: 'utf-8' },
				{ 'http-equiv': 'x-ua-compatible', content: 'ie=edge' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{
					name: 'description',
					content:
						'We are a fashion network which guarantees to every user visibility. Write articles, share your style and become influencer! Glossiq is a new way to talk about fashion.',
				},
				{ name: 'robots', content: 'index,follow,noodp' },
				{ name: 'google-site-verification', content: 'nAivUwodBvLYpVxUaXfiiGM8uzbe8H0BCx43a0K_02M' },
			],
		},
		FBSettings: { appId: '1757198084573864', pixelId: '630225225547909' },
		googleSettings: {
			analyticsId: 'UA-121069131-1', //UA-121075404-1
			tagManagerId: 'GTM-W63LQTP', //demo key: GTM-NGQH6H2
			adclient: 'ca-pub-4439767289267779',
			mapsApi: 'AIzaSyDvfhtJHBrztXvBDCwhDWIbaA7a7M-Pl3Y',
		},
		stripeSettings: {
			publicKey:
				'pk_live_51N8iekEojTmxH5ikJmFSK9Bm0kMmpGzXcsB45X65ZrmuHlchPFkpxFqEqzQbR29CWiaNIsc19W6RMqss5Jb3fNqi00W5XEDNIr',
		}, //demo: pk_test_3U8Qc0aekvPmbrboDub58IpC00cdvoe3sG
		baseUrlClient: 'https://www.glossiq.com',
		baseAPI: 'https://api.glossiq.com/', //pazi na kon�ni slash!
		authSettings: { baseUrlIdentity: 'https://sso.glossiq.com', clientId: 'Glossiq', domain: 'glossiq.com' }, //{ baseUrlClient: 'https://demobsPortal.b-s.si', baseUrlIdentity: 'https://ssobsPortal.b-s.si', clientId:'Glossiq', domain: 'devoia.com' },
	},
};

module.exports = config;
